import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { Layout } from 'blaze-validator';
import LoyaltyContext from './LoyaltyContext';
import ModalContext from '../modal/ModalContext';
import { updateCustomerLayout } from './layouts';
import LoadingPage from '../LoadingPage';
import FileNotFound from '../FileNotFound';
import Form from '../form/Form';
import '../../styles/loyalty.scss';

// res hushes TS inference problems
// eslint-disable-next-line
const CustomerUpdate = ({
  customerId,
  handleCancel,
  onCreate,
  onUpdate = res => {},
  initialValues = {},
  query = {},
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [readonly, setReadonly] = useState(false);
  const { fetchCustomer, createCustomer, updateCustomer, loyaltyCultureCode, loyaltyDealerCode, getDealerNetwork } =
    useContext(LoyaltyContext);
  const { setTitle, close } = useContext(ModalContext);
  const layout = useRef(new Layout(updateCustomerLayout));

  const defaultOnCreate = () => {};

  const getCustomer = id => {
    setError('');
    getDealerNetwork().then(({ data: dealers }) => {
      fetchCustomer(id)
        .then(response => {
          if (setTitle) {
            setTitle(`Updating ${response.data.firstName} ${response.data.lastName}`);
          }

          layout.current.populateLayout(response.data);

          if (!dealers.includes(response.data.preferredDealer)) {
            setReadonly(true);
          }

          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          setError('Error retrieving customer information');
        });
    });
  };

  const submit = payload => {
    if (customerId) {
      return updateCustomer(customerId, payload);
    }

    return createCustomer(payload);
  };

  const renderBody = () => {
    if (loading) {
      return <LoadingPage message="Looking up Customer" />;
    }

    if (error) {
      return <FileNotFound className="error">{error}</FileNotFound>;
    }

    const submitCallback = customerId ? onUpdate : onCreate || defaultOnCreate;

    return (
      <Form
        layout={layout.current.getLayout()}
        onCancel={close || handleCancel}
        submit={submit}
        submitCallback={submitCallback}
        exportFormat="object"
        submitAll
        resetOnSubmit={!customerId}
        initialValues={{ ...initialValues, ...query }}
        readOnly={readonly}
      />
    );
  };

  useEffect(() => {
    if (customerId) {
      getCustomer(customerId);
    } else {
      if (setTitle) {
        setTitle('Create Loyalty Customer');
      }

      const country = /-CA$/.test(loyaltyCultureCode) ? 'CA' : 'US';
      layout.current.populateLayout({ preferredDealer: loyaltyDealerCode, country });
      setLoading(false);
    }
  }, []);

  return <div className="loyalty-customer-update">{renderBody()}</div>;
};

CustomerUpdate.propTypes = {
  customerId: PropTypes.number,
  handleCancel: PropTypes.func,
  onUpdate: PropTypes.func,
  onCreate: PropTypes.func,
};

export default CustomerUpdate;
